<template>
  <div class="navbar">
    <el-menu  :default-active="activeIndex" mode="horizontal" active-text-color="#FFFFFF" text-color="#FFFFFF" background-color="#004e96">
      <el-menu-item v-for="(path,pathIndex) in menList" :key="pathIndex" v-if="path.visible==='1'" style="font-size: 18px;font-weight: 400;font-family: 微软雅黑;padding:0px 25px 0px 25px" :index="path.name" @click="jump(path.name)">{{path.name}}</el-menu-item>
    </el-menu>
  </div>
</template>
<script>
import request from "../../../utils/request";
import {getSystemId} from "../../../utils/systemInfo";
import getSystem from "../../../utils/getSystem";

export default {
  name:'navigationBar',
  props:{
    defaultActive:{
      type:String,
      required:true,
    }
  },
  data(){
    return{
      menList:[],
      home:false,
      activeIndex:'首页',
    }
  },
  methods:{
    async getRouteList(){
      if(getSystemId()===''||getSystemId()===null||getSystemId()===undefined){
        await getSystem.getSystemInfo()
      }
      request({
        url:'portalController/getMenu',
        methods: 'get',
        params:{
          belong:getSystemId()
        }
      }).then(rsp=>{
        if(rsp.resultCode==='0'){
          this.menList=rsp.data
        }
      })
    },
    jump(name){
      console.log(name)
      this.activeIndex=name
      if(name==='首页'){
        this.$router.push({path:'/home',query:{}})
      }
      if(name==='标准体系'){
        this.$router.push({path:'/system',query:{}})
      }
      if(name==='资源体系'){
        this.$router.push({path:'/standardSystem',query:{}})
      }
      if(name==='映射视图'){
        this.$router.push({path:'/mapping',query:{}})
      }
      if(name==='动态'){
        this.$router.push({path:'/detail',query:{}})
      }
      if(name==='标准解读'){
        this.$router.push({path:'/standardExplain',query:{}})
      }
      if(name==='政策解读'){
        this.$router.push({path:'/policyExplain',query:{}})
      }
      if(name==='文件下载'){
        this.$router.push({path:'/fileDownLoad',query:{}})
      }
      if(name==='关于标委会'){
        this.$router.push({path:'/tcAbout',query:{name:name}})
      }
      if(name==='关于我们'){
        this.$router.push({path:'/about',query:{name:name}})
      }
    }
  },
  mounted(){
    this.getRouteList()
    this.activeIndex=this.defaultActive
  }
}
</script>
<style>
.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 5px solid #ffffff !important;
}
.el-menu--horizontal>.el-menu-item{
  height: 65px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home/compoment/navigationBar.vue